import React from "react";
import { UserData } from "@/entities/users/types";
import { useTranslation } from "react-i18next";
import GenericBulkActionPopover, {
  BulkAction
} from "@/components/ui/BulkActionPopover";

const TRANSLATION_KEY = "settings.userManagement.bulkActions";

interface BulkActionPopoverProps {
  selectedUsers: UserData[];
  onReportsTo: () => void;
  onChangeRole: () => void;
  onActivate?: () => void;
  onDeactivate?: () => void;
  onClose: () => void;
  showChangeRole: boolean;
  showActivate: boolean;
  showDeactivate: boolean;
}

const BulkActionPopover: React.FC<BulkActionPopoverProps> = ({
  selectedUsers,
  onReportsTo,
  onChangeRole,
  onActivate,
  onDeactivate,
  onClose,
  showChangeRole,
  showActivate,
  showDeactivate
}) => {
  const { t } = useTranslation();

  const actions: BulkAction[] = [
    {
      key: "reportsTo",
      label: t(`${TRANSLATION_KEY}.reportsTo`),
      onClick: onReportsTo
    },
    {
      key: "changeRole",
      label: t(`${TRANSLATION_KEY}.changeRole`),
      onClick: onChangeRole,
      show: showChangeRole
    },
    {
      key: "deactivate",
      label: t(`${TRANSLATION_KEY}.deactivate`),
      onClick: onDeactivate || (() => {}),
      show: showDeactivate
    },
    {
      key: "activate",
      label: t(`${TRANSLATION_KEY}.activate`),
      onClick: onActivate || (() => {}),
      show: showActivate
    }
  ];

  return (
    <GenericBulkActionPopover
      selectedCount={selectedUsers.length}
      selectedText={t("settings.userManagement.bulkActions.selected")}
      actions={actions}
      onClose={onClose}
    />
  );
};

export default BulkActionPopover;
